import { useMatches } from '@remix-run/react';

import type { Publication } from '~/interfaces/publication';

const usePublication = (): Publication => {
  return useMatches()
    .map((match) => match.data)
    .filter((data) => Boolean(data.publication))?.[0]?.publication;
};

export default usePublication;
